// frontend/src/pages/Constitution.js
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import '../styles/Constitution.css';
import IndianEmblem from '../images/indian-national-emblem.png';

const Constitution = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleNavigateToArticles = () => {
    navigate('/articles'); // Navigate to the articles page
  };

  return (
    <div className="constitution-container">
      <h1 className="constitution-title">THE CONSTITUTION OF INDIA</h1>
      <img src={IndianEmblem} alt="Indian National Emblem" className="constitution-image" />
      <div className="constitution-content">
        <h2 className="constitution-heading">PREAMBLE</h2>
        <p>
          <span className="highlight1">WE, THE PEOPLE OF INDIA,</span> having solemnly resolved to constitute India into a 
          <span className="highlight1"> SOVEREIGN SOCIALIST SECULAR DEMOCRATIC REPUBLIC  </span> 
          and to secure to all its citizens:
        </p>
        <p>
          <span className="highlight1">JUSTICE,</span> social, economic and political;
          <br />
          <span className="highlight1">LIBERTY</span> of thought, expression, belief, faith and worship;
          <br />
          <span className="highlight1">EQUALITY</span> of status and of opportunity;
          <br />
          and to promote among them all 
          <span className="highlight1"> FRATERNITY</span> assuring the dignity of the individual and the 
          <span className="highlight1"> unity and integrity of the Nation</span>;
        </p>
        <p>
          IN OUR CONSTITUENT ASSEMBLY this twenty-sixth day of November, 1949, do HEREBY ADOPT, ENACT AND GIVE TO OURSELVES THIS CONSTITUTION.
        </p>
        <p className="constitution-note">
          ______________________________________________<br />
          1. Subs. by the Constitution (Forty-second Amendment) Act, 1976, s.2, for "SOVEREIGN DEMOCRATIC REPUBLIC" (w.e.f. 3-1-1977).<br />
          2. Subs. by s. 2, ibid., for "Unity of the Nation" (w.e.f. 3-1-1977).
        </p>
      </div>
      <div className="button-group">
        <button onClick={handleNavigateToArticles} className="scrolling-button">Articles</button>
        <button className="scrolling-button">Schedules</button>
        <button className="scrolling-button">Amendments</button>
        <button className="scrolling-button">Appendices</button>
      </div>
    </div>
  );
};

export default Constitution;
